export default __webpack_public_path__ + "static/media/whatsapp.1671b63e.svg";